import defaultImage from 'assets/img/theme/iconG4.png';
import ImageService from './service';
const MD5 = require('crypto-js/md5');

export const getProfileImage = async (
  setProfileImage,
  userLogin,
  setIsLoading
) => {
  setIsLoading(true);

  if (!userLogin) {
    setProfileImage(defaultImage);
    setIsLoading(false);
    return;
  }

  try {
    const filename = `${MD5(userLogin)}.png`;
    const res = await ImageService.get(filename);

    if (!res || res.status !== 200 || !res.data) {
      setProfileImage(defaultImage);
      setIsLoading(false);
      return;
    }

    const blob = res.data;
    const reader = new window.FileReader();

    reader.onload = function () {
      setProfileImage(reader.result);
      setIsLoading(false);
    };

    reader.onerror = function () {
      setProfileImage(defaultImage);
      setIsLoading(false);
    };

    reader.readAsDataURL(blob);
  } catch (err) {
    setProfileImage(defaultImage);
    setIsLoading(false);
  }
};
